import Vue from "vue";
import VueApollo from "vue-apollo";
import defaultClient from "./vue-appsync-client";

const apolloProvider = new VueApollo({ defaultClient });

Vue.use(VueApollo);

export default apolloProvider;
